import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Edit, NucleoCameraRecordFilmMeetings } from '@lyearn/icons';
import { Box, Button, Stack, Typography } from '@lyearn/ui';
import VideoPlayer from '@/components/VideoPlayer';

const LOADER_HEIGHT = 316;

interface GeneratedVideoProps {
  videoUrl: string;
  captionUrl?: string;
  editable?: boolean;
  duration?: string;
  onEditVideoClick: () => void;
}

const GeneratedVideo = (props: GeneratedVideoProps) => {
  const { videoUrl, captionUrl, editable, duration, onEditVideoClick } = props;
  const { t } = useTranslation('Course');

  const tracks = captionUrl
    ? [
        {
          label: 'English',
          src: captionUrl,
          key: 'en',
          srcLang: 'en',
          kind: 'captions' as const,
        },
      ]
    : undefined;

  if (!editable) {
    return (
      <VideoPlayer
        allowForwarding
        allowPlaybackSpeedControl
        loaderHeight={LOADER_HEIGHT}
        tracks={tracks}
        url={videoUrl}
      />
    );
  }

  return (
    <Box className="border-border border rounded-12 overflow-hidden">
      <VideoPlayer
        allowForwarding
        allowPlaybackSpeedControl
        loaderHeight={LOADER_HEIGHT}
        tracks={tracks}
        url={videoUrl}
      />
      <Stack
        alignItems="center"
        className="px-16 py-12 border-t border-border"
        direction="row"
        justifyContent="between">
        <Stack alignItems="center" direction="row" gap={8}>
          <NucleoCameraRecordFilmMeetings className="text-text-paragraph" />
          <Typography color="text-text-paragraph" variant="body-short-03">
            {t('Course:AiVideoGeneration.AiVideo')}
          </Typography>
          {duration ? (
            <>
              <Typography color="text-text-secondary" variant="body-short-03">
                •
              </Typography>
              <Typography color="text-text-secondary" variant="body-short-03">
                {duration}
              </Typography>
            </>
          ) : null}
        </Stack>
        <Button
          StartIcon={Edit}
          shape="square"
          size="x-small"
          variant="outlined"
          onClick={onEditVideoClick}>
          Edit Video
        </Button>
      </Stack>
    </Box>
  );
};

export default GeneratedVideo;
